import React from 'react';
import { Chip, useTheme, Typography } from '@mui/material';

interface BetaBadgeProps {
  label?: string | React.ReactNode;
  isSelected?: boolean;
}

export function BetaBadge({ label = 'Beta', isSelected = false }: BetaBadgeProps) {
  const theme = useTheme();

  return (
    <Chip
      label={
        <Typography variant="labelSmProminent" component="span">
          {label}
        </Typography>
      }
      size="small"
      sx={{
        backgroundColor: isSelected ? theme.palette.brand.primary : theme.palette.common.white,
        color: isSelected ? theme.palette.common.white : theme.palette.grey[600],
        border: isSelected ? 'none' : `2px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.spacing(1.25),
        height: theme.spacing(2.25),
        // Match the tab header's pointer cursor since the badge sits inside the tab
        cursor: 'pointer',
        '& .MuiChip-label': {
          padding: `${theme.spacing(0.25)} ${theme.spacing(2)}`,
          lineHeight: 'normal',
        },
      }}
    />
  );
}
